module.exports = __webpack_public_path__ + "img/watch_active_icon.523e5110.svg";